module.exports = __webpack_public_path__ + "img/厨房.0fafa3e4.png";